import type { StageConfig } from '@capture/shared';
import { MinimumRoleSelect } from './MinimumRoleSelect';
import { StageDeepLinks } from './StageDeepLinks';

export function KeyEntryPanel({ config, onChange }: { config: StageConfig; onChange: (c: StageConfig) => void }) {
  const fieldSet = (config.config.fieldSet as string) ?? 'all';
  const minimumRole = (config.config.minimumRole as string) ?? 'keyer';
  const blind = Boolean(config.config.blindDoubleKey);
  return (
    <div className="stage-panel">
      <label>
        Field set
        <select value={fieldSet} onChange={(e) => onChange({ ...config, config: { ...config.config, fieldSet: e.target.value } })}>
          <option>all</option>
          <option>needs-edit</option>
          <option>required-only</option>
        </select>
      </label>
      <label>
        Minimum role
        <MinimumRoleSelect value={minimumRole} onChange={(v) => onChange({ ...config, config: { ...config.config, minimumRole: v } })} />
      </label>
      <label>
        <input
          type="checkbox"
          checked={blind}
          onChange={(e) => onChange({ ...config, config: { ...config.config, blindDoubleKey: e.target.checked } })}
        />
        Blind double-key
      </label>
      <StageDeepLinks stage="key-entry" />
    </div>
  );
}
